import axiosInstance from '../axios';

const contestantService = {
  // Get contestants for a specific category
  getCategoryContestants: async (categoryId, params = {}) => {
    const { page = 1, pageSize = 100 } = params;
    const queryParams = new URLSearchParams({ page, pageSize });
    
    const response = await axiosInstance.get(`/contestants/category/${categoryId}?${queryParams}`);
    return response.data;
  },

  // Get single contestant by ID
  getContestantById: async (contestantId) => {
    const response = await axiosInstance.get(`/contestants/${contestantId}`);
    return response.data;
  },

  // Create contestant (with photo upload)
  createContestant: async (formData) => {
    const response = await axiosInstance.post('/contestants', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Update contestant (with optional photo upload)
  updateContestant: async (contestantId, formData) => {
    const response = await axiosInstance.put(`/contestants/${contestantId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Delete contestant
  deleteContestant: async (contestantId) => {
    const response = await axiosInstance.delete(`/contestants/${contestantId}`);
    return response.data;
  },

  // Get contestant statistics
  getContestantStats: async (contestantId) => {
    const response = await axiosInstance.get(`/contestants/${contestantId}/stats`);
    return response.data;
  }
};

export default contestantService;